import React from "react";
import contextProvider from "../../contextProvider";
import { Link } from "react-router-dom";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import ReactOCollapse from "../../_L1_components/Elements/ReactOCollapse";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import ReactODropdown from "../../_L1_components/Elements/ReactODropdown";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";

class ReactOTable extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      sorting: [],
    };
    super(props, initState);
  }

  setSort(data_key, _add_multiple, order) {
    //		console.log("DEBUG :: ReactOTable _ setSort");
    let oneway_sort = this.props.cols.find((value) => {
      return value.data_key == data_key;
    }).oneway_sort;
    this.setState((prev_state) => {
      if (_add_multiple) {
        let _sorting_field = prev_state.sorting.find((value) => {
          return value.data_key == data_key;
        });
        if (_sorting_field) {
          oneway_sort
            ? (_sorting_field.order = oneway_sort)
            : (_sorting_field.order =
                order !== undefined ? order : !_sorting_field.order);
        } else {
          prev_state.sorting.push({ data_key: data_key, order: true });
        }
      } else {
        prev_state.sorting = [
          (() => {
            let _sorting_field = prev_state.sorting.find((value) => {
              return value.data_key == data_key;
            }) || { data_key: data_key, order: false };
            oneway_sort
              ? (_sorting_field.order = oneway_sort)
              : (_sorting_field.order =
                  order !== undefined ? order : !_sorting_field.order);
            return _sorting_field;
          })(),
        ];
      }

      return prev_state;
    });
  }

  sort(rows) {
    // console.log("DEBUG :: ReactOTable _ sort", rows);
    let parseValue = (raw_value) => {
      let _value = typeof raw_value == "object" ? raw_value.value : raw_value;
      return /^[-+]{0,1}[0-9]+[,|.]*[0-9]*$/.test(_value)
        ? parseFloat(_value)
        : typeof _value == "string"
        ? _value.toLowerCase()
        : _value;
    };
    rows.sort((a, b) => {
      let _compare_res = 0;
      this.state.sorting.every((_CURR_sort_field, _CURR_idx) => {
        if (
          a[_CURR_sort_field.data_key] !== undefined &&
          b[_CURR_sort_field.data_key] !== undefined
        ) {
          let a_parsed = parseValue(a[_CURR_sort_field.data_key]);
          let b_parsed = parseValue(b[_CURR_sort_field.data_key]);
          if (_CURR_sort_field.order === true) {
            if (a_parsed > b_parsed) {
              _compare_res = 1;
              return false;
            }
            if (a_parsed < b_parsed) {
              _compare_res = -1;
              return false;
            }
          } else {
            if (b_parsed > a_parsed) {
              _compare_res = 1;
              return false;
            }
            if (b_parsed < a_parsed) {
              _compare_res = -1;
              return false;
            }
          }
        }
        return true;
      });
      return _compare_res;
    });
    rows.sort((a, b) => {
      let _compare_res = 0;
      this.state.sorting.every((_CURR_sort_field, _CURR_idx) => {
        if (
          _CURR_sort_field.constrain !== undefined &&
          _CURR_sort_field.func !== undefined
        ) {
          let a_parsed = parseValue(a[_CURR_sort_field.data_key]);
          let b_parsed = parseValue(b[_CURR_sort_field.data_key]);
          if (_CURR_sort_field.func(a_parsed)) {
            _compare_res = _CURR_sort_field.constrain == "down" ? 1 : -1;
            return false;
          }
          if (_CURR_sort_field.func(b_parsed)) {
            _compare_res = _CURR_sort_field.constrain == "down" ? -1 : 1;
            return false;
          }
        }
        return true;
      });
      return _compare_res;
    });
    return rows;
  }

  //
  //	Lifecycle methods
  //

  onComponentDidMount() {
    // console.log("DEBUG :: ReactOTable _ onComponentDidMount");
    if (this.props.defaultSort) {
      this.setState((prev_state) => {
        (Array.isArray(this.props.defaultSort)
          ? this.props.defaultSort
          : [this.props.defaultSort]
        ).forEach((_CURR_sort_default, _CURR_idx) => {
          prev_state.sorting.push({
            data_key: _CURR_sort_default.data_key,
            ...(_CURR_sort_default.order !== undefined
              ? { order: _CURR_sort_default.order == "asc" ? true : false }
              : {}),
            ...(_CURR_sort_default.constrain !== undefined
              ? { constrain: _CURR_sort_default.constrain, func: _CURR_sort_default.func }
              : {}),
          });
        });
        return prev_state;
      });
    }
  }

  onComponentWillUnmount() {}

  onGetChildContext() {
    return {};
  }

  onRender() {
    return (
      <div className="d-flex">
        <div className="flex-grow-1 table-responsive-xl">
          <table
            className={
              "table" +
              (this.props.striped ? " table-striped" : "") +
              (this.props.size ? (this.props.size == "sm" ? " table-sm" : "") : "") +
              (this.props.hoverable ? " table-hover" : "") +
              (this.props.bordless ? "table-borderless" : "")
            }
            style={this.props.style}
            onMouseLeave={
              this.props.onTableLeave
                ? () => {
                    this.props.onTableLeave();
                  }
                : null
            }
          >
            {this.props.compressed ? (
              this.props.rows.length ? (
                <tbody>
                  <tr>
                    <td>
                      <ReactOActionBar
                        className="px-2 py-1"
                        backgroundColor={
                          this.props.compressedDark
                            ? this.getAppContext().colors.gray800
                            : this.getAppContext().colors.gray150
                        }
                        padding="0"
                        align="right"
                      >
                        {!this.props.cols.find((value) => {
                          return value.sortable;
                        }) ? (
                          <ReactOButton size="sm" outline disabled>
                            {this.state.sorting.length
                              ? this.props.cols.find((value) => {
                                  return value.data_key == this.state.sorting[0].data_key;
                                }).title +
                                (this.state.sorting[0].order
                                  ? " ascending"
                                  : " descending")
                              : "-"}
                          </ReactOButton>
                        ) : (
                          <ReactODropdown
                            color={this.props.compressedDark ? "light" : "secondary"}
                            size="sm"
                            outline={this.props.compressedDark ? false : true}
                            toggler={
                              this.state.sorting.length
                                ? (() => {
                                    let _foundCol = this.props.cols.find((value) => {
                                      return (
                                        value.data_key == this.state.sorting[0].data_key
                                      );
                                    });
                                    if (_foundCol) {
                                      return (
                                        <span>
                                          {_foundCol.title}{" "}
                                          {this.state.sorting[0].order
                                            ? " ascending"
                                            : " descending"}
                                        </span>
                                      );
                                    } else {
                                      this.setSort(
                                        (this.props.cols || []).find((value) => {
                                          return value.sortable;
                                        }).data_key,
                                        false,
                                        true
                                      );
                                    }
                                  })()
                                : "-"
                            }
                            options={(() => {
                              let _opts = [];
                              (this.props.cols || [])
                                .filter((value) => {
                                  return value.title !== undefined;
                                })
                                .forEach((_CURR_col, _CURR_idx) => {
                                  if (_CURR_col.sortable) {
                                    _opts.push({
                                      name: <span>{_CURR_col.title} ascending</span>,
                                      value: _CURR_col.data_key,
                                      onClick: (e) => {
                                        this.setSort(
                                          _CURR_col.data_key,
                                          e.shiftKey,
                                          true
                                        );
                                      },
                                    });
                                    _opts.push({
                                      name: <span>{_CURR_col.title} descending</span>,
                                      value: _CURR_col.data_key,
                                      onClick: (e) => {
                                        this.setSort(
                                          _CURR_col.data_key,
                                          e.shiftKey,
                                          false
                                        );
                                      },
                                    });
                                  }
                                });
                              return _opts;
                            })()}
                          />
                        )}
                      </ReactOActionBar>
                    </td>
                  </tr>
                </tbody>
              ) : null
            ) : this.props.cols &&
              this.props.cols.find((value) => {
                return value.title !== undefined;
              }) ? (
              <thead className="thead-light">
                <tr>
                  {this.props.cols.map((_CURR_col, _CURR_idx) => {
                    if (_CURR_col.data_key == "_collapse_indicator") {
                      return (
                        <th
                          key={_CURR_idx}
                          className="text-center"
                          style={{ width: "100px" }}
                        />
                      );
                    }
                    return (
                      <th
                        key={_CURR_idx}
                        scope="col"
                        className={
                          "text-nowrap text-muted " +
                          (this.props.thClassName ? this.props.thClassName : "") +
                          (this.props.thDividers ? " dividers" : "") +
                          (_CURR_col.sortable ? " sortable" : "")
                        }
                        style={{
                          ...(_CURR_col.width ? { width: _CURR_col.width + "%" } : {}),
                        }}
                        {...(_CURR_col.sortable
                          ? {
                              onClick: (e) => {
                                this.setSort(_CURR_col.data_key, e.shiftKey);
                              },
                            }
                          : {})}
                      >
                        <div
                          className={
                            "d-flex justify-content-" +
                            (_CURR_col.align == "center"
                              ? "center"
                              : _CURR_col.align == "right"
                              ? "end"
                              : "start")
                          }
                        >
                          <small className="">
                            <strong>
                              {_CURR_col.title}
                              {_CURR_col.icon ? (
                                <span
                                  className={
                                    "text-nowrap sorting-caret " + _CURR_col.icon
                                  }
                                />
                              ) : null}
                              {(() => {
                                let _sorting_idx = 0;
                                let _sorting_field = this.state.sorting.find(
                                  (value, idx) => {
                                    _sorting_idx = idx;
                                    return value.data_key == _CURR_col.data_key;
                                  }
                                );
                                //let _sorting_idx = this.state.sorting.findIndex((value) => {return value.data_key == _CURR_col.data_key;});
                                return _sorting_field && _CURR_col.sortable ? (
                                  <span
                                    className={
                                      "text-nowrap sorting-caret icon-" +
                                      (_sorting_idx == 0
                                        ? _sorting_field.order == true
                                          ? "caret-up"
                                          : "caret-down"
                                        : "caret-up-down")
                                    }
                                  />
                                ) : null;
                              })()}
                            </strong>
                          </small>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
            ) : null}

            <tbody>
              {(this.props.rows ? this.sort(this.props.rows) : []).map(
                (_CURR_row, _CURR_idx) => {
                  let _row_content = this.props.compressed
                    ? (() => {
                        let row_items = {};
                        let link = false;
                        (this.props.cols || []).forEach((_CURR_col, _CURR_idx) => {
                          let _td_c = (() => {
                            let _render = "";
                            if (
                              _CURR_row[_CURR_col.data_key] &&
                              typeof _CURR_row[_CURR_col.data_key] == "object" &&
                              _CURR_row[_CURR_col.data_key].render
                            ) {
                              _render = _CURR_row[_CURR_col.data_key].render;
                            } else {
                              _render = _CURR_row[_CURR_col.data_key];
                            }
                            return /string|object|number/.test(typeof _render)
                              ? _render
                              : typeof _render == "function"
                              ? _render()
                              : "";
                          })();

                          if (_CURR_row._link) {
                            link = _CURR_row._link;
                          }

                          row_items[_CURR_col.data_key] = {
                            title: _CURR_col.title,
                            content: _td_c,
                          };
                        });

                        if (this.props.compressedRowRendering) {
                          return (
                            <td>{this.props.compressedRowRendering(row_items, link)}</td>
                          );
                        } else {
                          return (
                            <td>
                              {(this.props.cols || []).map((_CURR_col, _CURR_idx) => {
                                let _td_c = (() => {
                                  let _render = "";
                                  if (
                                    _CURR_row[_CURR_col.data_key] &&
                                    typeof _CURR_row[_CURR_col.data_key] == "object" &&
                                    _CURR_row[_CURR_col.data_key].render
                                  ) {
                                    _render = _CURR_row[_CURR_col.data_key].render;
                                  } else {
                                    _render = _CURR_row[_CURR_col.data_key];
                                  }
                                  return /string|object|number/.test(typeof _render)
                                    ? _render
                                    : typeof _render == "function"
                                    ? _render()
                                    : "";
                                })();
                                return (
                                  <div key={_CURR_idx}>
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{_CURR_col.title}</strong>
                                      </small>
                                    </div>
                                    {_td_c}
                                  </div>
                                );
                              })}
                            </td>
                          );
                        }
                      })()
                    : (this.props.cols || []).map((_CURR_col, _CURR_idx) => {
                        if (
                          _CURR_col.data_key == "_collapse_indicator" &&
                          _CURR_row._collapsed
                        ) {
                          return (
                            <td
                              key={_CURR_idx}
                              className="text-center"
                              style={{ width: "60px" }}
                            >
                              <span
                                className={
                                  _CURR_row._collapse_ctrl &&
                                  _CURR_row._collapse_ctrl.isOpened()
                                    ? "icon-minus"
                                    : "icon-plus"
                                }
                              />
                            </td>
                          );
                        }
                        let _td_c = (() => {
                          let _render = "";
                          if (
                            _CURR_row[_CURR_col.data_key] &&
                            typeof _CURR_row[_CURR_col.data_key] == "object" &&
                            _CURR_row[_CURR_col.data_key].render
                          ) {
                            _render = _CURR_row[_CURR_col.data_key].render;
                          } else {
                            _render = _CURR_row[_CURR_col.data_key];
                          }
                          return /string|object|number/.test(typeof _render)
                            ? _render
                            : typeof _render == "function"
                            ? _render()
                            : "";
                        })();
                        return (
                          <td
                            key={_CURR_idx}
                            className={
                              " " + (this.props.tdClassName ? this.props.tdClassName : "")
                            }
                            style={{
                              ...(_CURR_col.width
                                ? { width: _CURR_col.width + "%" }
                                : {}),
                            }}
                            title={_CURR_row._title || ""}
                          >
                            {_CURR_row._link ? (
                              <Link
                                // title={_CURR_row._title || ""}
                                className="link-table-test"
                                to={_CURR_row._link}
                              >
                                <div
                                  className={
                                    "d-flex justify-content-" +
                                    (_CURR_col.align == "center"
                                      ? "center"
                                      : _CURR_col.align == "right"
                                      ? "end"
                                      : "start")
                                  }
                                >
                                  <span
                                    className={
                                      "w-100 " +
                                      (_CURR_col.align == "center"
                                        ? "text-center"
                                        : _CURR_col.align == "right"
                                        ? "text-right"
                                        : "text-left")
                                    }
                                  >
                                    {_td_c}
                                  </span>
                                </div>
                              </Link>
                            ) : (
                              <div
                                className={
                                  "d-flex justify-content-" +
                                  (_CURR_col.align == "center"
                                    ? "center"
                                    : _CURR_col.align == "right"
                                    ? "end"
                                    : "start")
                                }
                              >
                                <span
                                  className={
                                    "w-100 " +
                                    (_CURR_col.align == "center"
                                      ? "text-center"
                                      : _CURR_col.align == "right"
                                      ? "text-right"
                                      : "text-left")
                                  }
                                >
                                  {_td_c}
                                </span>
                              </div>
                            )}
                          </td>
                        );
                      });

                  return [
                    <tr
                      id={
                        _CURR_row._rowTooltip && _CURR_row._rowTooltip.targetId
                          ? _CURR_row._rowTooltip.targetId
                          : null
                      }
                      key={_CURR_idx}
                      onClick={
                        this.props.onRowClick
                          ? () => {
                              this.props.onRowClick(_CURR_row);
                            }
                          : null
                      }
                      onMouseOver={
                        this.props.onRowOver
                          ? () => {
                              this.props.onRowOver(_CURR_row);
                            }
                          : null
                      }
                      style={{
                        // ...(this.props.hoverable ? { cursor: "pointer" } : {}),
                        ...(_CURR_row._color
                          ? { backgroundColor: _CURR_row._color }
                          : {}),
                      }}
                      className={
                        (_CURR_row._collapsed &&
                        _CURR_row._collapse_ctrl &&
                        _CURR_row._collapse_ctrl.isOpened()
                          ? " collapse-open"
                          : "") + (_CURR_row.className ? " " + _CURR_row.className : "")
                      }
                    >
                      {_row_content}
                      {_CURR_row._rowTooltip ? (
                        <ReactOTooltip
                          placement="bottom"
                          delay={_CURR_row._rowTooltip.delay || null}
                          target={_CURR_row._rowTooltip.targetId}
                          text={_CURR_row._rowTooltip.text}
                        />
                      ) : null}
                    </tr>,
                    _CURR_row._collapsed ? (
                      <tr>
                        <td colspan="3">
                          <ReactOCollapse
                            key={_CURR_idx + ".2"}
                            onControllerReady={(_collapse_controller) => {
                              _CURR_row._collapse_ctrl = _collapse_controller;
                            }}
                            onOpened={() => {
                              this.setState({ _advanced_collapse_opened: true });
                            }}
                            onClosed={() => {
                              this.setState({ _advanced_collapse_opened: false });
                            }}
                          >
                            {_CURR_row._collapsed()}
                          </ReactOCollapse>
                        </td>
                      </tr>
                    ) : null,
                  ];
                }
              )}
            </tbody>
          </table>
          {!this.props.rows ||
          (this.props.rows.length == 0 && this.props.emptyMessage) ? (
            <div className="text-center text-muted my-3">{this.props.emptyMessage}</div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default contextProvider(
  ReactOTable,
  //	withDefinedContext(ReactOTable, 'ReactOTable', context_exposed_methods, true),
  {
    retrieve: null,
  }
);
